<template>
    <div>
        <div class="row">
            <div class="col-lg-8 col-md-6 col-12 bundle-border-right">
                <div class="row">
                    <div class="col-lg-4 col-md-12 col-12">
                        <label for="selCategory">Category:</label>
                        <select id="selCategory" class="form-select" v-model="selectedCategory">
                            <!--<option value="0">All</option>-->
                            <!--<option value="REG">Regular Load</option>-->
                            <option selected value="SP">Smart Prepaid</option>
                            <option value="TNT">TNT</option>
                            <option value="SBP">Smart Bro Prepaid</option>
                            <option value="SBHW">Smart Bro Home Wifi</option>
                            <!--<option value="PLDT">PLDT</option>
                            <option value="CIGNAL">Cignal</option>
                            <option value="MERALCO">Meralco</option>-->
                        </select>
                    </div>
                    <div class="col-lg-8 col-md-12 col-12">
                        <label>Filter:</label>
                        <div class="input-group">
                            <span class="input-group-text text-body">
                                <i class="fas fa-search" aria-hidden="true"></i>
                            </span>
                            <input type="text" class="form-control" placeholder="Search Products" v-model="searchKey" />
                        </div>
                    </div>
                </div>
                <div class="card-body px-0 pt-0 pb-2">
                    <div class="table-responsive bundle-table p-0">
                        <table class="table align-items-center mb-0">
                            <thead>
                                <tr>
                                    <th>
                                        <!--<input class="" type="checkbox" value="" id="defaultCheck1">-->
                                    </th>
                                    <th> Category </th>
                                    <th> Offer </th>
                                    <th> SRP </th>
                                    <th> Description </th>
                                    <th> Validity </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="loading">
                                    <td colspan="7">
                                        <div class="text-center">
                                            <Vue3Lottie :animationData="searchingJSON" class="height-150 py-2" />
                                        </div>
                                    </td>
                                </tr>
                                <tr v-if="!loading && pageItems.length == 0">
                                    <td colspan="7">
                                        <div class="text-center">
                                            <Vue3Lottie :animationData="noDataJSON" class="height-150 py-2" />
                                            <p class="text-xs font-weight-bold">No Data Found</p>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-for="(product, index) in pageItems" :key="index"
                                    @click="product.checked = !product.checked" style="cursor: pointer">
                                    <td class="text-center">
                                        <input type="checkbox" v-model="product.checked" />
                                    </td>
                                    <td>
                                        <p class="sub-text">
                                            {{ product.brand }}
                                        </p>
                                    </td>
                                    <td>
                                        <div class="d-flex flex-column justify-content-center">
                                            <p class="main-text"> {{ product.offer }}</p>
                                            <sub class="text-muted"> {{ product.family }}</sub>
                                        </div>
                                    </td>
                                    <td>
                                        <span class="badge badge-sm bg-gradient-info" v-if="product.srp > 0">
                                            Php {{ product.srp.toFixed(2) }}
                                        </span>
                                        <span class="badge badge-sm bg-gradient-info" v-if="product.srp == 0">-</span>
                                    </td>
                                    <td>
                                        <div style="max-width: 500px;" class="text-wrap">
                                            <p class="sub-text">
                                                {{ product.description }}
                                            </p>
                                        </div>
                                    </td>
                                    <td>
                                        <p class="sub-text">
                                            {{ product.validity }} Days
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="paginate-div d-flex align-items-end mt-3 me-3">
                        <vue-awesome-paginate class="ms-auto" :max-pages-shown="5"
                            :total-items="filteredProducts.length" :items-per-page="itemPerPage"
                            :on-click="onPageChanged" v-model="localCurrentPage" />
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12">
                <div class="d-flex justify-content-between">
                    <h6>Bundled Items ({{ bundledCount }})</h6>
                    <h6>Total Amount: &#8369;{{ bundledTotal.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) }}</h6>
                </div>
                <div class="bundle-right-container">
                    <div v-for="(product, index) in selectedProducts" :key="index"
                        class="bundle-item d-flex justify-content-between align-items-center">
                        <div class="ms-2 me-2">
                            <small>{{ product.brand }}</small>
                            <h6 class="mb-0">{{ product.offer }}</h6>
                            <small>{{ product.family }}</small>
                        </div>
                        <div class="ms-2 me-2 bundle-description">
                            <small>{{ product.description }}</small>
                        </div>
                        <div>
                            <span class="badge badge-sm bg-gradient-info">
                                Php {{ product.srp.toFixed(2) }}
                            </span>
                        </div>
                        <div class="ms-2 me-2">
                            <img src="/img/delete.png" class="bundle-delete-icon" alt="logo"
                                @click="removeProduct(product)" />
                        </div>
                    </div>
                </div>
                <form class="mt-3" @submit.prevent="createBundle">
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>Bundle Name</label>
                                <div class="mb-3">
                                    <input type="text" class="form-control" v-model="bundleForm.name" required />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--<div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>Category</label>
                                <div class="mb-3">
                                    <input type="text" class="form-control" v-model="bundleForm.category" required />
                                </div>
                            </div>
                        </div>
                    </div>-->
                    <!--<div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>Offer</label>
                                <div class="mb-3">
                                    <input type="text" class="form-control" v-model="bundleForm.offer" />
                                </div>
                            </div>
                        </div>
                    </div>-->
                    <!--<div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>ELP Keyword</label>
                                <div class="mb-3">
                                    <input type="text" class="form-control" v-model="bundleForm.keyword" required />
                                </div>
                            </div>
                        </div>
                    </div>-->
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>SRP</label>
                                <div class="mb-3">
                                    <input type="number" class="form-control" v-model="bundleForm.srp" min="0"
                                        @input="preventNegativeSRP" required />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>Description</label>
                                <div class="mb-3">
                                    <textarea type="text" class="form-control" v-model="bundleForm.description"
                                        required />
                                </div>
                            </div>
                        </div>
                    </div>
                    <button type="submit" class="btn bg-gradient-dark mb-0 btn-block w-100">
                        Create Bundle
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import noDataJSON from "./../../../assets/no-data.json";
import searchingJSON from "./../../../assets/searching.json";

export default {
    data() {
        return {
            noDataJSON,
            searchingJSON,
            itemPerPage: 20,
            pageItems: [],
            filteredProducts: [],
            selectedCategory: 'SP', //this is hard coded
            searchKey: '',
            bundleForm: {
                name: '',
                keyword: '',
                srp: '',
                description: '',
                totalAmount: ''
            },
            localCurrentPage: 1,
        };
    },
    computed: {
        ...mapState({
            loading: (state) => state.productController.loading,
            products: (state) => state.productController.products,
        }),
        anyProductChecked() {
            return this.pageItems.some(p => p.checked);
        },
        selectedProducts() {
            return this.products.filter(p => p.checked);
        },
        bundledCount() {
            return this.selectedProducts.length;
        },
        bundledTotal() {
            return this.selectedProducts.reduce((total, product) => {
                return total + (parseFloat(product.srp) || 0);
            }, 0);
        },
    },
    watch: {
        products: {
            handler(newValue, oldValue) {
                this.updatePageItems();
            },
            deep: true,
            immediate: true,
        },
        selectedCategory() {
            this.localCurrentPage = 1;
            this.updatePageItems();
        },
        searchKey() {
            this.localCurrentPage = 1;
            this.updatePageItems();
        },
    },
    methods: {
        ...mapActions({
            getProducts: "productController/GetProducts",
            createBundleAPI: "productController/CreateBundle",
        }),
        updatePageItems() {
            let filtered = this.products.filter(
                p => p.categoryCode === this.selectedCategory &&
                    p.isVisible &&
                    (p.brand || '').trim().toLowerCase() !== "bundle"
            );

            if (this.searchKey.trim() !== '') {
                const keyword = this.searchKey.toLowerCase();
                filtered = filtered.filter(
                    p =>
                        (p.offer && p.offer.toLowerCase().includes(keyword)) ||
                        (p.family && p.family.toLowerCase().includes(keyword)) ||
                        (p.description && p.description.toLowerCase().includes(keyword)) ||
                        (p.keyword && p.keyword.toLowerCase().includes(keyword))
                );
            }

            this.filteredProducts = filtered;

            const totalPages = Math.ceil(this.filteredProducts.length / this.itemPerPage);
            const safePage = Math.min(this.localCurrentPage, totalPages) || 1;

            this.onPageChanged(safePage);
        },
        onPageChanged(page) {
            this.localCurrentPage = page;
            this.pageItems = this.filteredProducts.slice(
                (page - 1) * this.itemPerPage,
                page * this.itemPerPage
            );
        },
        removeProduct(product) {
            product.checked = false;
        },
        async createBundle() {
            // TO ADD
            // if (this.selectedProducts.length < 2) {
            //     alert('Please provide at least 2 products');
            //     return;
            // }

            const bundlePayload = {
                BundleName: this.bundleForm.name,
                // BundleKeyword: this.bundleForm.keyword,
                BundleSRP: parseFloat(this.bundleForm.srp),
                BundleDescription: this.bundleForm.description,
                ProductIDs: this.selectedProducts.map(p => p.productID),
                BundleTotalAmount: this.bundledTotal,
                CategoryCode: this.selectedCategory
            };

            try {
                await this.$store.dispatch("productController/CreateBundle", bundlePayload);
                alert("Bundle created successfully!");

                this.bundleForm = {
                    name: '',
                    offer: '',
                    keyword: '',
                    srp: '',
                    description: ''
                };
                this.selectedProducts = [];
                this.products.forEach(p => p.checked = false);
                this.pageItems.forEach(p => p.checked = false);

                await this.getProducts();
            } catch (err) {
                console.error(err);
                alert("There was an error creating the bundle.");
            }
        },
    },
    async mounted() {
        await this.getProducts();
    },
};
</script>